<template>
  <div
    v-on-click-outside="
      () => {
        isOpened = false
      }
    "
    class="r-search"
  >
    <div class="r-search-input">
      <div class="r-search-input__current-type" :class="{ expanded: isOpened }">
        <input
          ref="inputBox"
          v-model="inputValue"
          :placeholder="selectedType.name"
          :type="selectedType.inputType"
          @keyup.enter="search"
        />
        <i-local-home-banner-arrow class="r-search-input__icon-dropdown" @click="isOpened = !isOpened" />
      </div>
      <Transition name="fade">
        <div v-if="isOpened" class="r-search-input__types elevation-10">
          <div
            v-for="one in searchTypes"
            :key="one.key"
            class="r-search-input__type"
            :class="{ selected: props.type == one.key }"
            @click="clickType(one.key)"
          >
            {{ one.name }}
          </div>
        </div>
      </Transition>
    </div>
    <i-local-search class="r-search-input__icon-search" @click="search" />
  </div>
</template>
<script setup lang="ts">
  import { vOnClickOutside } from '@vueuse/components'

  interface Props {
    type: string
    modelValue: string
  }

  const props = defineProps<Props>()
  const emits = defineEmits(['update:type', 'update:modelValue'])

  const inputValue = ref(props.modelValue)

  const inputBox = ref()

  watch(
    () => props.modelValue,
    () => {
      inputValue.value = props.modelValue
    }
  )

  const searchTypes = ref([
    {
      key: 'character-name',
      name: 'Character Name',
      inputType: 'text',
    },
    // {
    //   key: 'guild-name',
    //   name: 'Guild Name',
    // },
    {
      key: 'ranks',
      name: 'Ranks',
      inputType: 'number',
    },
  ])
  const selectedType = computed(() => searchTypes.value.find((x) => x.key === props.type) ?? searchTypes.value[0])
  const isOpened = ref(false)

  function search() {
    // emits('update:type', selectedType.value.key)
    emits('update:modelValue', inputValue.value)
  }

  function clickType(typeKey: string) {
    emits('update:type', typeKey)
    isOpened.value = false
    inputBox.value.focus()
  }
</script>
<style lang="scss" scoped>
  .r-search {
    display: flex;
  }
  .r-search-input {
    position: relative;
    width: 200px;
    font-size: 17px;
    font-weight: 400;
    font-style: normal;
    color: var(--content-text-color);
    line-height: 24px;
    background-color: white;
    &__current-type {
      display: flex;
      align-items: center;
      padding: 1px 0 1px 20px;
      width: 100%;
      background-color: inherit;
      position: relative;
      height: 40px;

      input {
        line-height: inherit;
        font-size: inherit;
        font-family: inherit;
        border: none;
        width: 100%;
        background: none !important;
        box-shadow: none;
        margin: 0;
        margin-right: 40px;
        padding: 0;
        outline: none;
        // border: 1px solid green;
      }
    }
    &__icon-dropdown {
      padding: 10px;
      width: 46px;
      height: 38px;

      position: absolute;
      right: -4px;
      z-index: 6;

      transform: rotate(-90deg);
      transition: transform 0.3s;
      cursor: pointer;

      :deep(path) {
        fill: #9f9f9f;
      }
      .expanded & {
        transform: rotate(90deg);
      }
      &:hover {
        :deep(path) {
          fill: #5a5753;
        }
      }
    }
    &__icon-search {
      // position: absolute;
      // right: -40px;
      padding: 8px;
      width: 38px;
      height: 40px;
      margin-left: 2px;
      // border: 1px solid green;
      color: #c93e2b;

      cursor: pointer;
      background-color: white;
      &:hover {
        color: #75251a;
      }
    }
    &__types {
      position: absolute;
      width: 100%;
      // border: 1px solid red;
      background-color: inherit;
      top: 0;
      z-index: 5;
    }
    &__type {
      padding: 8px 20px;
      cursor: pointer;
      &.selected {
        font-weight: 600;
      }
      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }
</style>
